import React, { FC } from 'react';
import { IDirectionTagsQueryNode } from '../../../queries/directionTags/types';
import { Card } from '../../common/Card';
import { GridWithSlider } from '../../common/GridWithSlider';
import useScreen from '../../../utils/hooks/useScreen';
import { t } from '../../../i18n';
import styles from './styles.module.scss';
import { TLink } from '../../../i18n/TLink';

interface IProps {
  nodes: IDirectionTagsQueryNode[];
  counts: Record<string, number>;
  from?: string;
}

const AboutTopDirections: FC<IProps> = ({ nodes, counts, from }) => {
  const { isMobile } = useScreen();
  const topDirections = [0, 1];

  return (
    <>
      <GridWithSlider>
        {topDirections.map((i) => (
          <Card
            node={nodes[i].node}
            key={`topDirection-${i + 1}`}
            from={from}
            headDirection={isMobile ? 'row-reverse' : 'row'}
          />
        ))}
      </GridWithSlider>
      <div className={styles.wrapper}>
        <img
          className={styles.imgCover}
          src="/case/internship/footer.png"
          alt=""
        />
        <div className={styles.banner}>
          <div className={styles.iconRound}>
            <img src="/case/internship/hat.svg" alt="" />
          </div>
          <div className={styles.textWrapper}>
            <div className={styles.title}>
              {t('cases.internship.title.title')}
            </div>
            <div className={styles.subtitle}>
              {t('cases.internship.title.desc')}
            </div>

            <TLink to="/internship/" className={styles.button}>
              {t('cases.internship.title.button')}
            </TLink>
          </div>
        </div>
      </div>
    </>
  );
};

export { AboutTopDirections };
